import Navbar from "../../features/app/Navbar";
import { Container } from "./styles";

interface NavbarProps {
  dashboardScreen: boolean;
  checkoutScreen?: boolean;
  darkText?: boolean;
}

const NavbarContainer = ({
  dashboardScreen,
  checkoutScreen = false,
  darkText,
}: NavbarProps) => {
  const isDarkText = darkText ?? dashboardScreen;
  return (
    <Container>
      <Navbar
        dashboardScreen={dashboardScreen}
        checkoutScreen={checkoutScreen}
        darkText={isDarkText}
      />
    </Container>
  );
};

export default NavbarContainer;
